import { ReactNode } from "react"
import {Link} from "react-router-dom";
import clsx from "clsx";

import {cButtonProps} from "../../utils";

export interface ButtonLinkProps extends cButtonProps {
  extraClassName?: string;
  url: string;
  isExternal?: boolean;
  title?: string;
  text?: string;
  children?: ReactNode;
}

function ButtonLink(
  {
    extraClassName,
    url,
    isExternal,
    text,
    title,
    children,
    btnColor,
    btnVariant,
    btnSize,
    icon,
    iconPlacement,
    ...props
  }: ButtonLinkProps) {

  return (
    <Link
      to={url}
      target={isExternal? "_blank" : undefined}
      rel={isExternal? "noreferrer noopener": undefined}
      className={clsx("c-button", extraClassName && extraClassName)}
      title={title ?? text ?? "Button Title"}
      aria-label={title ?? text ?? "Button Title"}
      data-color={btnColor && btnColor}
      data-variant={btnVariant && btnVariant}
      data-size={btnSize && btnSize}
      data-icon-placement={iconPlacement && iconPlacement}
      {...props}
    >
      {icon && <i>{icon}</i>}
      {text ? <span>{text}</span> : children}
    </Link>
  )
}

export default ButtonLink
